import { render, staticRenderFns } from "./ButtonInfo.vue?vue&type=template&id=4c6ce15e"
import script from "./ButtonInfo.vue?vue&type=script&lang=js"
export * from "./ButtonInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports